import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	recommendedSection: {
		id: 'command-palette-quick-search.common.recommended.recommended-section',
		defaultMessage: 'Recommended',
		description: 'Section title for Recommended commands',
	},
	viewAllIssues: {
		id: 'command-palette-quick-search.common.recommended.view-all-issues',
		defaultMessage: 'View all issues',
		description: 'Command palette command that links to issues search',
	},
	viewAllProjects: {
		id: 'command-palette-quick-search.common.recommended.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'Command palette command that links to projects',
	},
	viewAllBoards: {
		id: 'command-palette-quick-search.common.recommended.view-all-boards',
		defaultMessage: 'View all boards',
		description: 'Command palette command that links to boards',
	},
	viewAllFilters: {
		id: 'command-palette-quick-search.common.recommended.view-all-filters',
		defaultMessage: 'View all filters',
		description: 'Command palette command that links to filters',
	},
	viewAllPlans: {
		id: 'command-palette-quick-search.common.recommended.view-all-plans',
		defaultMessage: 'View all plans',
		description: 'Command palette command that links to plans',
	},
});
